var exports = {
  "kL": "container__VHc0qA",
  "Jd": "newFile__vJd9AJ",
  "G_": "deletedFile__LD7LAR",
};

module.exports = exports;
